import { z } from "zod"

export enum WorkflowStatus {
  ACTIVE = 'active',
  PROCESSING = 'processing',
  IN_ACTIVE = 'inactive',
  PENDING = 'pending',
  DELETED = 'deleted'
}

export enum WorkflowTriggerTypeDisplayName {
  MANUALLY = 'Manually',
  AUTOMATICALLY = 'Automatically',
  ON_Schedule = 'On Schedule',
}

export const workflowRunTypes = [{
  title: WorkflowTriggerTypeDisplayName.MANUALLY,
  description: 'The workflow starts when you manually click a button to run it each time.'
}, {
  title: WorkflowTriggerTypeDisplayName.AUTOMATICALLY,
  description: 'The workflow runs when an event happens.'
}, {
  title: WorkflowTriggerTypeDisplayName.ON_Schedule,
  description: 'The workflow runs on a schedule (i.e.every single day).'
}]

export const WorkflowCreateLegacySchema = z.object({
  nickname: z.string().min(1, {
    message: 'Please give this workflow a nickname.'
  }),
  credentialSource: z.string().min(1, {
    message: 'Please select a credential for this source.'
  }),
  credentialSourceOptional: z.string().optional(),
  triggerType: z.string().min(1, {
    message: 'Please select a trigger type.'
  }),
  // only for schedule
  scheduleType: z.string().optional(),
  scheduleDay: z.string().optional(),
  scheduleTime: z.string().optional(),
  timezone: z.string().optional()
})

export const WorkflowCreateSchema = z.object({
  nickname: z.string().min(1, {
    message: 'Please give this workflow a nickname.'
  }),
  sourceAction: z.string().min(1, {
    message: 'Please select what you want to do with this Source.'
  }),
  sourceSubject: z.string().min(1, {
    message: 'Please select what subject you want to work with this Source.'
  }),
  sourceCredential: z.string().min(1, {
    message: 'Please select Credential for this Source.'
  })
})

export const WorkflowUpdateSchema = z.object({
  nickname: z.string().min(1, {
    message: 'Please give this workflow a nickname.'
  }),
  sourceCredential: z.string().min(1, {
    message: 'Please select Credential for this Source.'
  })
})

export const WorkflowCreateUpdateSchemaV2 = z.object({
  nickname: z.string().min(1, {
    message: 'Please give this workflow a nickname.'
  })
})

export const WorkflowExecutionSchedule = z.object({
  frequency: z.string().optional(),
  additional: z.string().optional(),
  timeOfDay: z.string().optional(),
})

export const DayCampTravelConfigSchema = z.object({
  name: z.string().min(1, {
    message: 'Please select configuration name.'
  }),
  busName: z.string().min(1, {
    message: 'Please select bus name.'
  }),
  toCamp: z.string().min(1, {
    message: 'Please select a bus while going to Camp.'
  }),
  fromCamp: z.string().min(1, {
    message: 'Please select a bus while coming from Camp.'
  })
})

export enum WorkflowDestinationFields {
  SEASON = 'season',
  FIELDS_TYPE = 'updated_fields',

  GOOGLE_DRIVE = 'google_drive',
  GOOGLE_SHEET = 'google_sheet',
  GOOGLE_SHEET_TABS = 'google_sheet_tab'
}

export enum WorkflowMessage {
  CREATE_SUCCESSFUL = 'Workflow created successfully.',
  UPDATE_SUCCESSFUL = 'Workflow updated successfully.',
  DELETE_SUCCESSFUL = 'Workflow deleted successfully.',
  REMOVE_WORKFLOW_DESTINATION = 'Destination is removed for the workflow',
  RUN_SUCCESSFUL = 'Workflow is now running.'
}

export enum WorkflowErrorMessage {
  CRED_MISMATCH_1 = 'credential is not be associated with datasource',
  CRED_MISMATCH_2 = 'credential can not be associated with datasource',
  MISSING_FIELD_OPTION = 'data source field option is required',
  WORKFLOW_NOT_SUPPORTED = 'this workflow is not supported yet',
  GET_TRIGGER_FILTERS_ERROR = 'Error on getting Trigger Filters',
  CM_CREDENTIAL_INVALID = 'camp minder credential is invalid',
  QUOTA_EXCEEDED = 'QUOTA_EXCEEDED'
}

export const formattedWorkflowMessage: Record<string, string> = {
  [WorkflowErrorMessage.CRED_MISMATCH_1]: 'Credential did\'nt matched with the application.',
  [WorkflowErrorMessage.CRED_MISMATCH_2]: 'Credential did\'nt matched with the application.',
  [WorkflowErrorMessage.MISSING_FIELD_OPTION]: `Field option is not selected for at least one fields. 
    Click on Manage Fields and then update field options for all source fields.`,
  [WorkflowErrorMessage.WORKFLOW_NOT_SUPPORTED]: 'This workflow is not supported yet.',
  [WorkflowErrorMessage.GET_TRIGGER_FILTERS_ERROR]: 'Error on getting Trigger Filters. Please refresh and try again.',
  [WorkflowErrorMessage.CM_CREDENTIAL_INVALID]: 'This CampMinder credentials is either expired or invalid. Please try again with new one.',
  [WorkflowErrorMessage.QUOTA_EXCEEDED]: 'Playbook quota reached. Add more playbooks in Billing or contact support for assistance.'
}
